import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Menu, MenuItem } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useStore } from 'src/stores';

// PMS values the backend has a dedicated preset for; anything else exports as the Full report.
const PMS_FORMATS = {
  buildium: 'Buildium',
  resman: 'ResMan',
  realpage: 'RealPage'
};
export const ChargeExportButton = observer(_ref => {
  let propertyId = _ref.propertyId,
    year = _ref.year,
    month = _ref.month;
  const store = useStore();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const inFlight = store.report.downloadChargeExportAsync.inProgress;
  const pms = (store.company.propertyManagementSoftware || '').trim().toLowerCase();
  const pmsFormat = PMS_FORMATS[pms] ? pms : null;
  const handleDownload = async format => {
    var _resp$headers$fileNa, _resp$headers;
    setAnchorEl(null);
    // createAsync (auto: true) surfaces its own error toast and resolves to undefined on failure,
    // so guard the response instead of adding a second toast.
    const resp = await store.report.downloadChargeExportAsync.run({
      propertyId,
      year,
      month,
      format
    });
    if (!(resp !== null && resp !== void 0 && resp.data)) return;
    const url = window.URL.createObjectURL(new Blob([resp.data], {
      type: 'application/octet-stream'
    }));
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', (_resp$headers$fileNa = (_resp$headers = resp.headers) === null || _resp$headers === void 0 ? void 0 : _resp$headers['file-name']) !== null && _resp$headers$fileNa !== void 0 ? _resp$headers$fileNa : "charges_".concat(year, "-").concat(month, ".csv"));
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  // No recognized PMS → a single Full-report export (chooser collapses to one button).
  if (!pmsFormat) {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      disabled: inFlight,
      onClick: () => handleDownload('full')
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "file-text"
    }), /*#__PURE__*/React.createElement("span", null, "Export charges"));
  }

  // Recognized PMS → split button: main action = the PMS preset, caret = Full report.
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    disabled: inFlight,
    onClick: () => handleDownload(pmsFormat)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-text"
  }), /*#__PURE__*/React.createElement("span", null, "Export (".concat(PMS_FORMATS[pms], ")"))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    disabled: inFlight,
    "aria-label": "export format options",
    onClick: e => setAnchorEl(e.currentTarget)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "triangle-down"
  })), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: () => setAnchorEl(null)
  }, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => handleDownload(pmsFormat)
  }, "".concat(PMS_FORMATS[pms], " format")), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => handleDownload('full')
  }, "Full report")));
});